import { useState } from 'react';
import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/slaDashboard';

/**
 * Hook to manage dashboard state for SLADashboard page
 * @returns {Object} Dashboard state and handlers
 */
export const useSLADashboardState = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [now, setNow] = useState(new Date());

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return {
    page,
    rowsPerPage,
    queries,
    loading,
    now,
    setPage,
    setRowsPerPage,
    setQueries,
    setLoading,
    setNow,
    handleChangePage,
    handleChangeRowsPerPage,
  };
};
